// utils/locale.js
export function getLocaleFromURL() {
    const pathSegments = window.location.pathname.split('/');
    const locale = pathSegments[1]; // The locale is the first segment of the URL
    return locale;
}
